export type HeadlinesDepartmentDto = {
  id: number;
  name: string;
  children: HeadlinesDepartmentDto[];
  commentResponses: number;
  hasSummary: boolean;
};

export type HeadlinesDepartmentsListResultDto = {
  items: HeadlinesDepartmentDto[];
};

export type HeadlinesDepartmentModel = {
  id: number;
  name: string;
  children: HeadlinesDepartmentsListResultModel;
  commentResponses: number;
  hasSummary: boolean;
};

export type HeadlinesDepartmentsListResultModel = {
  items: HeadlinesDepartmentModel[];
};

export const mapHeadlinesDepartmentDtoToModel = (
  dto: HeadlinesDepartmentDto
): HeadlinesDepartmentModel => ({
  id: dto.id,
  name: dto.name,
  children: { items: dto.children.map(mapHeadlinesDepartmentDtoToModel) },
  commentResponses: dto.commentResponses,
  hasSummary: dto.hasSummary,
});

export const mapHeadlinesDepartmentsListResultDtoToModel = (
  dto: HeadlinesDepartmentsListResultDto
): HeadlinesDepartmentsListResultModel => ({
  items: dto.items.map(mapHeadlinesDepartmentDtoToModel),
});
